// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./NixieOne-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./images/1920_1080.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./images/background_for_mobile.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* * {font-family: MHeiHK, Helvetica Neue, Helvetica, Arial, Microsoft JhengHei, 微軟正黑體, sans-serif;} */

@font-face {
  font-family: 'CustomFont';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
   body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'CustomFont';
    color: #8E701A;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 100vh; /* Use min-height to allow content to expand */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .background-image {
    /*background-image: url("white_image.jpg");
  background-size: cover;
  background-position: center;*/
  background-color: rgba(255, 255, 255, 0.7);
  height: 10vh; /* Adjust height as needed */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  }
  
/*---------------login------------------*/
 .title-box {
    display: flex;
    flex-direction: row;margin-bottom: 20px;
} 
.sign_up-title {
    color: #d7bc79;font-size:25px;
    padding: 0px 10px 0px 0px; margin: 0px;
}
 .line {
    flex: 1 0 auto;
    position: relative;
    margin-right: 10px;
}
.title-box .line::before {
    width: 100%;
    height: 2px;
    position: absolute;
    top: 50%;
    left: 0px;
    content: "";
    background: #d3c274;
    transition: all .3s;
}
.sign_up-container{
    padding: 10px 50px;
    margin: auto;
}
/*---------------login------------------*/



  .content { 
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding-bottom: 20px; /* Increased to ensure content clears footer */
    min-height: 10vh; /* Ensure content takes at least full viewport height */
    box-sizing: border-box;
  } 
  /* .title-container { 
    /*position: absolute; 
    left: 50%; 
    transform: translateX(-50%); 
  */

  .content h2 { 
    margin: 0; font-weight: bold; color:#947728;    font-size: 30px;text-align: center;
  } 
  .btn { 
    margin-left: auto; 
    margin-right: 10px; 
  }
  
  .background-image img{padding: 10px;}
  
  /* .logout-button-container {
    display: flex;
    justify-content: flex-end;
    /* width: 100%;
    position: absolute;
    right: 10%;
    padding-right: 20px;*/

  .language-switch {
    display: flex;
    box-shadow: 3px 3px 0.96px rgba(192, 188, 188, 0.25);
    order: 1; /* Ensure language-switch is last in flex order */
  }

  .language-button {
    width: 60px;
    height: 35px;
    background-color: #fff;
    color: #000000;
    border: none;
    border-radius: 50px 0 0 50px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'CustomFont';
    font-size: 14px;
  }

  .language-button + .language-button {
    border-radius: 0 50px 50px 0;
    border-left: 1px solid rgba(192, 188, 188, 0.25);
  }

  .language-button:hover {
    background-color: #fff;
    color: #5A5454;
  }

/*top bar*/
  .top-bar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 8%;
    background-color: rgba(255, 255, 255, 0.79); 
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }

  .top-bar-right {
    margin-left: auto; /* Push to the right */
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px; /* Space between Logout and LanguageSwitcher */
    padding-right: 15px;
  }

  .btn.btn-outline-danger {
    border: 1px solid #dc3545;
    color: #dc3545;
    background-color: transparent;
    padding: 5px 15px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
  }
  
  .btn.btn-outline-danger:hover {
    background-color: #dc3545;
    color: white;
  }


  .logo {
    max-height: 70%;
    max-width: 70%;
    position: absolute; /* Center the logo */
    left: 50%;
    transform: translateX(-50%); /* Center horizontally */
  }
  .btn btn-outline-danger {
    right: 20%
  }

  .main-title {
    text-align: center;
    margin: 0;
    font-size: 25px;
    margin-top: 0px;
    margin-bottom: 0px; 
  }


  .first-page-box {
    border-radius: 5px;
    background-color: #FAECE0;
    color: #8E701A;
    width: 100%;
    height: auto;
    max-width: 570px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 40px;
    font-family: "CustomFont";
  }
  
  .first-page-top-box {
    height: 7%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 30px;
  }


  /*footer*/ 
  .app-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 1rem;
    background-color: #f8f9fa;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: center;
    z-index: 1000; /* Increased z-index to ensure footer stays on top */
  }
  
  .footer-content {
    max-width: 1200px;
    display: flex;
    flex-direction: row; /* Horizontal layout for social and address */
    justify-content: center; /* Center the content */
    align-items: center; /* Vertically align items */
    gap: 20px; /* Space between social and address sections */
  }
  
  .company-name {
    font-weight: 600;
    font-size: 1.1rem;
    color: #333;
  }
  
  .social-section a {
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    color: #333;
  }
  
  .instagram-icon {
    color: #E1306C;
    transition: color 0.3s ease;
  }
  
  .social-section a:hover .instagram-icon {
    color: #C13584;
  }
  
  .description {
    font-size: 0.9rem;
    transition: color 0.3s ease;
  }
  
  .social-section a:hover .description {
    color: #C13584;
  }

  .address-section {
    font-size: 0.9rem;
    color: #333;
    text-align: center;
  }
  
  .address-section p {
    margin: 0; /* Remove default margin for cleaner alignment */
  }


  /* Mobile styles (applied below 768px) */
@media (max-width: 768px) {
  body {
    position: relative;
    min-height: 100vh;
    padding-bottom: 150px; /* Increased to account for footer and scaling */
    box-sizing: border-box;
    transform: scale(0.8);
    transform-origin: top left;
    width: 125%;
    min-height: calc(100vh / 0.8 + 150px); /* Adjusted for scaling and footer */
    overflow-x: hidden;
  }
  /* Ensure content doesn't get hidden behind footer */
  .content {
    margin-bottom: 50px; /* Ensure content clears the footer */
    padding-bottom: 50px; /* Extra padding to prevent overlap */
  }


  .top-bar {
    padding: 10px;
    flex-direction: row; /* Keep row direction for alignment */
    align-items: center;
    height: auto; /* Allow top bar to grow */
  }

  .top-bar-right {
    gap: 8px; /* Slightly reduce gap for smaller screens */
    justify-content: flex-end;
    margin-left: auto;
    padding-right: 6px;
  }

  .logo {
    height: 40px;
    margin-bottom: 10px;
    position: relative;
    left: 38%;
    transform: translateX(-50%);
  }

  .logout-button-container {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .language-button {
    width: 50px;
    height: 30px;
    font-size: 12px;
  }

  .app-footer {
    position: fixed;
    width: 100%;
    padding: 0.5rem;
    bottom: 0;
    z-index: 1000; /* Ensure footer stays above content */
  }

  .footer-content {
    flex-direction: column; /* Stack vertically on mobile */
    gap: 10px; /* Reduce gap for mobile */
    justify-content: center;
    align-items: center;
  }

  .address-section {
    font-size: 0.8rem; /* Slightly smaller font for mobile */
  }
  

  /* Adjust buttons for touch */
  button {
    padding: 8px 16px;
    font-size: 14px;
  }


  body {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: contain;
    background-repeat: repeat;
    background-position: top center;
    background-attachment: fixed;
  }

  /*logout button*/
  

  .btn.btn-outline-danger {
    padding: 4px 12px;
    font-size: 12px;
  }

}

/* Desktop styles */
@media (min-width: 769px) {
  /* .top-bar {
    padding: 20px 40px;
  } */
}

/* For very small screens like iPhone SE */
@media (max-width: 320px) {
  body {
    padding-bottom: 180px; /* Further increased for iPhone SE */
    min-height: calc(100vh / 0.8 + 180px); /* Account for footer and scaling */
  }

  .content {
    padding-bottom: 180px; /* Ensure content clears footer */
    margin-bottom: 180px; /* Prevent overlap */
  }

  .top-bar {
    padding: 8px;
  }

  .top-bar-right {
    gap: 6px; /* Further reduce gap for iPhone SE */
  }


  .app-footer {
    padding: 0.5rem;
    font-size: 0.8rem;
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1000; /* Ensure footer stays on top */
  }

  .footer-content {
    flex-wrap: wrap;
    justify-content: center;
    gap: 5px;
  }

}
`, "",{"version":3,"sources":["webpack://./src/components/index.css"],"names":[],"mappings":"AAAA,sGAAsG;;AAEtG;EACE,yBAAyB;EACzB,+DAAqD;AACvD;GACG;IACC,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,yDAA+C;IAC/C,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,iBAAiB,EAAE,8CAA8C;IACjE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE;;+BAE2B;EAC7B,0CAA0C;EAC1C,YAAY,EAAE,4BAA4B;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX;;AAEF,yCAAyC;CACxC;IACG,aAAa;IACb,mBAAmB,CAAC,mBAAmB;AAC3C;AACA;IACI,cAAc,CAAC,cAAc;IAC7B,yBAAyB,EAAE,WAAW;AAC1C;CACC;IACG,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA,yCAAyC;;;;EAIvC;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB,EAAE,8CAA8C;IACpE,gBAAgB,EAAE,uDAAuD;IACzE,sBAAsB;EACxB;EACA;;;;GAIC;;EAED;IACE,SAAS,EAAE,iBAAiB,EAAE,aAAa,KAAK,eAAe,CAAC,kBAAkB;EACpF;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,sBAAsB,aAAa,CAAC;;EAEpC;;;;;;yBAMuB;;EAEvB;IACE,aAAa;IACb,oDAAoD;IACpD,QAAQ,EAAE,iDAAiD;EAC7D;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,gDAAgD;EAClD;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;AAEF,UAAU;EACR;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;IACV,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB,EAAE,sBAAsB;IACzC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS,EAAE,8CAA8C;IACzD,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;;EAGA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB,EAAE,oBAAoB;IACxC,SAAS;IACT,2BAA2B,EAAE,wBAAwB;EACvD;EACA;IACE;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;;EAGA,SAAS;EACT;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,aAAa,EAAE,oDAAoD;EACrE;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB,EAAE,6CAA6C;IAClE,uBAAuB,EAAE,uBAAuB;IAChD,mBAAmB,EAAE,2BAA2B;IAChD,SAAS,EAAE,8CAA8C;EAC3D;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,SAAS,EAAE,gDAAgD;EAC7D;;;EAGA,wCAAwC;AAC1C;EACE;IACE,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB,EAAE,gDAAgD;IACvE,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;IAC1B,WAAW;IACX,qCAAqC,EAAE,oCAAoC;IAC3E,kBAAkB;EACpB;EACA,oDAAoD;EACpD;IACE,mBAAmB,EAAE,qCAAqC;IAC1D,oBAAoB,EAAE,qCAAqC;EAC7D;;;EAGA;IACE,aAAa;IACb,mBAAmB,EAAE,qCAAqC;IAC1D,mBAAmB;IACnB,YAAY,EAAE,0BAA0B;EAC1C;;EAEA;IACE,QAAQ,EAAE,4CAA4C;IACtD,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;IACf,SAAS;IACT,aAAa,EAAE,sCAAsC;EACvD;;EAEA;IACE,sBAAsB,EAAE,+BAA+B;IACvD,SAAS,EAAE,0BAA0B;IACrC,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB,EAAE,qCAAqC;EAC1D;;;EAGA,6BAA6B;EAC7B;IACE,iBAAiB;IACjB,eAAe;EACjB;;;EAGA;IACE,yDAA2D;IAC3D,wBAAwB;IACxB,yBAAyB;IACzB,+BAA+B;IAC/B,4BAA4B;EAC9B;;EAEA,gBAAgB;;;EAGhB;IACE,iBAAiB;IACjB,eAAe;EACjB;;AAEF;;AAEA,mBAAmB;AACnB;EACE;;KAEG;AACL;;AAEA,0CAA0C;AAC1C;EACE;IACE,qBAAqB,EAAE,oCAAoC;IAC3D,qCAAqC,EAAE,mCAAmC;EAC5E;;EAEA;IACE,qBAAqB,EAAE,iCAAiC;IACxD,oBAAoB,EAAE,oBAAoB;EAC5C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ,EAAE,qCAAqC;EACjD;;;EAGA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa,EAAE,+BAA+B;EAChD;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,QAAQ;EACV;;AAEF","sourcesContent":["/* * {font-family: MHeiHK, Helvetica Neue, Helvetica, Arial, Microsoft JhengHei, 微軟正黑體, sans-serif;} */\n\n@font-face {\n  font-family: 'CustomFont';\n  src: url('./NixieOne-Regular.ttf') format('truetype');\n}\n   body {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: 'CustomFont';\n    color: #8E701A;\n    background-image: url('./images/1920_1080.png');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    min-height: 100vh; /* Use min-height to allow content to expand */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .background-image {\n    /*background-image: url(\"white_image.jpg\");\n  background-size: cover;\n  background-position: center;*/\n  background-color: rgba(255, 255, 255, 0.7);\n  height: 10vh; /* Adjust height as needed */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  }\n  \n/*---------------login------------------*/\n .title-box {\n    display: flex;\n    flex-direction: row;margin-bottom: 20px;\n} \n.sign_up-title {\n    color: #d7bc79;font-size:25px;\n    padding: 0px 10px 0px 0px; margin: 0px;\n}\n .line {\n    flex: 1 0 auto;\n    position: relative;\n    margin-right: 10px;\n}\n.title-box .line::before {\n    width: 100%;\n    height: 2px;\n    position: absolute;\n    top: 50%;\n    left: 0px;\n    content: \"\";\n    background: #d3c274;\n    transition: all .3s;\n}\n.sign_up-container{\n    padding: 10px 50px;\n    margin: auto;\n}\n/*---------------login------------------*/\n\n\n\n  .content { \n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n    padding-bottom: 20px; /* Increased to ensure content clears footer */\n    min-height: 10vh; /* Ensure content takes at least full viewport height */\n    box-sizing: border-box;\n  } \n  /* .title-container { \n    /*position: absolute; \n    left: 50%; \n    transform: translateX(-50%); \n  */\n\n  .content h2 { \n    margin: 0; font-weight: bold; color:#947728;    font-size: 30px;text-align: center;\n  } \n  .btn { \n    margin-left: auto; \n    margin-right: 10px; \n  }\n  \n  .background-image img{padding: 10px;}\n  \n  /* .logout-button-container {\n    display: flex;\n    justify-content: flex-end;\n    /* width: 100%;\n    position: absolute;\n    right: 10%;\n    padding-right: 20px;*/\n\n  .language-switch {\n    display: flex;\n    box-shadow: 3px 3px 0.96px rgba(192, 188, 188, 0.25);\n    order: 1; /* Ensure language-switch is last in flex order */\n  }\n\n  .language-button {\n    width: 60px;\n    height: 35px;\n    background-color: #fff;\n    color: #000000;\n    border: none;\n    border-radius: 50px 0 0 50px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'CustomFont';\n    font-size: 14px;\n  }\n\n  .language-button + .language-button {\n    border-radius: 0 50px 50px 0;\n    border-left: 1px solid rgba(192, 188, 188, 0.25);\n  }\n\n  .language-button:hover {\n    background-color: #fff;\n    color: #5A5454;\n  }\n\n/*top bar*/\n  .top-bar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 8%;\n    background-color: rgba(255, 255, 255, 0.79); \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n  }\n\n  .top-bar-right {\n    margin-left: auto; /* Push to the right */\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px; /* Space between Logout and LanguageSwitcher */\n    padding-right: 15px;\n  }\n\n  .btn.btn-outline-danger {\n    border: 1px solid #dc3545;\n    color: #dc3545;\n    background-color: transparent;\n    padding: 5px 15px;\n    border-radius: 4px;\n    font-size: 14px;\n    cursor: pointer;\n  }\n  \n  .btn.btn-outline-danger:hover {\n    background-color: #dc3545;\n    color: white;\n  }\n\n\n  .logo {\n    max-height: 70%;\n    max-width: 70%;\n    position: absolute; /* Center the logo */\n    left: 50%;\n    transform: translateX(-50%); /* Center horizontally */\n  }\n  .btn btn-outline-danger {\n    right: 20%\n  }\n\n  .main-title {\n    text-align: center;\n    margin: 0;\n    font-size: 25px;\n    margin-top: 0px;\n    margin-bottom: 0px; \n  }\n\n\n  .first-page-box {\n    border-radius: 5px;\n    background-color: #FAECE0;\n    color: #8E701A;\n    width: 100%;\n    height: auto;\n    max-width: 570px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    padding: 40px;\n    font-family: \"CustomFont\";\n  }\n  \n  .first-page-top-box {\n    height: 7%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 10px;\n    margin-bottom: 30px;\n  }\n\n\n  /*footer*/ \n  .app-footer {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 1rem;\n    background-color: #f8f9fa;\n    border-top: 1px solid #dee2e6;\n    display: flex;\n    justify-content: center;\n    z-index: 1000; /* Increased z-index to ensure footer stays on top */\n  }\n  \n  .footer-content {\n    max-width: 1200px;\n    display: flex;\n    flex-direction: row; /* Horizontal layout for social and address */\n    justify-content: center; /* Center the content */\n    align-items: center; /* Vertically align items */\n    gap: 20px; /* Space between social and address sections */\n  }\n  \n  .company-name {\n    font-weight: 600;\n    font-size: 1.1rem;\n    color: #333;\n  }\n  \n  .social-section a {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    text-decoration: none;\n    color: #333;\n  }\n  \n  .instagram-icon {\n    color: #E1306C;\n    transition: color 0.3s ease;\n  }\n  \n  .social-section a:hover .instagram-icon {\n    color: #C13584;\n  }\n  \n  .description {\n    font-size: 0.9rem;\n    transition: color 0.3s ease;\n  }\n  \n  .social-section a:hover .description {\n    color: #C13584;\n  }\n\n  .address-section {\n    font-size: 0.9rem;\n    color: #333;\n    text-align: center;\n  }\n  \n  .address-section p {\n    margin: 0; /* Remove default margin for cleaner alignment */\n  }\n\n\n  /* Mobile styles (applied below 768px) */\n@media (max-width: 768px) {\n  body {\n    position: relative;\n    min-height: 100vh;\n    padding-bottom: 150px; /* Increased to account for footer and scaling */\n    box-sizing: border-box;\n    transform: scale(0.8);\n    transform-origin: top left;\n    width: 125%;\n    min-height: calc(100vh / 0.8 + 150px); /* Adjusted for scaling and footer */\n    overflow-x: hidden;\n  }\n  /* Ensure content doesn't get hidden behind footer */\n  .content {\n    margin-bottom: 50px; /* Ensure content clears the footer */\n    padding-bottom: 50px; /* Extra padding to prevent overlap */\n  }\n\n\n  .top-bar {\n    padding: 10px;\n    flex-direction: row; /* Keep row direction for alignment */\n    align-items: center;\n    height: auto; /* Allow top bar to grow */\n  }\n\n  .top-bar-right {\n    gap: 8px; /* Slightly reduce gap for smaller screens */\n    justify-content: flex-end;\n    margin-left: auto;\n    padding-right: 6px;\n  }\n\n  .logo {\n    height: 40px;\n    margin-bottom: 10px;\n    position: relative;\n    left: 38%;\n    transform: translateX(-50%);\n  }\n\n  .logout-button-container {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n  }\n\n  .language-button {\n    width: 50px;\n    height: 30px;\n    font-size: 12px;\n  }\n\n  .app-footer {\n    position: fixed;\n    width: 100%;\n    padding: 0.5rem;\n    bottom: 0;\n    z-index: 1000; /* Ensure footer stays above content */\n  }\n\n  .footer-content {\n    flex-direction: column; /* Stack vertically on mobile */\n    gap: 10px; /* Reduce gap for mobile */\n    justify-content: center;\n    align-items: center;\n  }\n\n  .address-section {\n    font-size: 0.8rem; /* Slightly smaller font for mobile */\n  }\n  \n\n  /* Adjust buttons for touch */\n  button {\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n\n\n  body {\n    background-image: url('./images/background_for_mobile.png');\n    background-size: contain;\n    background-repeat: repeat;\n    background-position: top center;\n    background-attachment: fixed;\n  }\n\n  /*logout button*/\n  \n\n  .btn.btn-outline-danger {\n    padding: 4px 12px;\n    font-size: 12px;\n  }\n\n}\n\n/* Desktop styles */\n@media (min-width: 769px) {\n  /* .top-bar {\n    padding: 20px 40px;\n  } */\n}\n\n/* For very small screens like iPhone SE */\n@media (max-width: 320px) {\n  body {\n    padding-bottom: 180px; /* Further increased for iPhone SE */\n    min-height: calc(100vh / 0.8 + 180px); /* Account for footer and scaling */\n  }\n\n  .content {\n    padding-bottom: 180px; /* Ensure content clears footer */\n    margin-bottom: 180px; /* Prevent overlap */\n  }\n\n  .top-bar {\n    padding: 8px;\n  }\n\n  .top-bar-right {\n    gap: 6px; /* Further reduce gap for iPhone SE */\n  }\n\n\n  .app-footer {\n    padding: 0.5rem;\n    font-size: 0.8rem;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    z-index: 1000; /* Ensure footer stays on top */\n  }\n\n  .footer-content {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 5px;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
